import { Link } from "react-router";

import { GROWTH_NAME } from "@/lib/growth";

import { IconCluster } from "./icon-cluster";

/**
 * Every Growth Intelligence route while the module is hidden (`GROWTH_LIVE` in lib/growth.ts).
 * The sidebar entry stays; it lands here (Figma 6126:52519).
 */
export function GrowthComingSoonPage() {
  return (
    <div className="flex min-h-full items-center justify-center py-10">
      <section
        aria-labelledby="gi-coming-soon"
        className="flex w-full max-w-[560px] flex-col items-center gap-5 rounded-3xl border border-border bg-[#faf6ef] px-6 pt-12 pb-10 text-center sm:px-12"
      >
        <IconCluster />
        <h1 id="gi-coming-soon" className="max-w-[324px] text-[22px] leading-[30px] font-bold text-fg">
          {GROWTH_NAME} is coming soon!
        </h1>
        <p className="max-w-[390px] text-[14.5px] leading-[22px] text-fg-muted">
          {GROWTH_NAME} monitors key regulations, competitors, and market shifts relevant to your business,
          providing ranked insights and actionable recommendations.
        </p>
        <Link
          to="/"
          className="rounded-full bg-brand-500 px-[26px] py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-brand-600"
        >
          ← Back to Home
        </Link>
      </section>
    </div>
  );
}
